import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {HttpRequestService} from '../_common/http-request.service';

@Injectable()
export class UserWebIosService {

    constructor(private http: HttpRequestService) {
    }

    gets(parameters: any) {
        return this.http.get(`getAllUser`, parameters)
            .map(res => {
                return res.json();
            })
    }

    activeModules(model: any) {
        return this.http.put(`updateIsModulesForUser`, model)
            .map(res => {
                return res.json();
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/user-web-ios.service.ts